import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'ling-page-section',
  templateUrl: './page-section.component.html',
  styleUrls: ['./page-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageSectionComponent {
  @Input() title = '';
  @Input() headerLink?: { path: string; text: string };
  @Input() sectionIcon!: string;

  @Output() iconClicked = new EventEmitter<string>();
}
